import { render, staticRenderFns } from "./ModalAddField.vue?vue&type=template&id=516f4fbd&scoped=true&"
import script from "./ModalAddField.vue?vue&type=script&lang=js&"
export * from "./ModalAddField.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddField.vue?vue&type=style&index=0&id=516f4fbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516f4fbd",
  null
  
)

export default component.exports